import React from "react";
import { usePermissions } from "@/hooks/usePermissions";
import { useAuth } from "@/pages/auth/auth";
import { Navigate } from "@tanstack/react-router";
import { UnauthorizedModuleFallback } from "./UnauthorizedModuleFallback";

type TRequireAuthProps = {
  allowedPermissions?: string[];
  checkAllPermissions?: boolean;
  children: React.ReactNode;
};

// PermissionGuard.tsx
const RoutePermissionGuard = ({
  allowedPermissions,
  checkAllPermissions,
  children,
}: TRequireAuthProps) => {
  const auth = useAuth();
  const { hasAnyPermission } = usePermissions();

  if (!auth.access_token) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!hasAnyPermission(allowedPermissions, checkAllPermissions)) {
    return <UnauthorizedModuleFallback />;
  }

  return children;
};

export default RoutePermissionGuard;
